import { Avatar, Button, Card, CardContent, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ModalXendit from "./ModalXendit";
import { useNavigate } from "react-router-dom";

const PaymentMethodXendit = ({idUser, id, setIsLoad, state, setState, channel}) => {
    const [dialog, setDialog] = useState(false);
    const [method, setMethod] = useState(null);
    const navigate = useNavigate();

    const handleDialog = (val) => {
        setDialog(val)
    }

    const handlePayment = (val) => {
        setMethod(val);
        setDialog(false);
    }

    const handlePayNow = () => {
        navigate(`/invoice/checkout?user_id=${idUser}&invoice_id=${id}&payment_channel=xendit&channel=${method}`)
    }

    return <>
            <ModalXendit dialog={dialog} handleDialog={handleDialog} handlePayment={handlePayment} channel={channel}/>
            <Card sx={{marginY: 3}}>
                <CardContent>
                    <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handleDialog(true)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handleDialog(true)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`Avatar ada`}
                                        src={process.env.PUBLIC_URL + '/xendit.svg'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary={
                                    <Fragment>
                                        <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            Xendit Indonesia
                                        </Typography>
                                    </Fragment>
                                } />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
            <Stack direction={"row"} alignItems={"center"} sx={{marginTop: 1, marginBottom: 0.5}}>
                <Typography variant="caption">Payment Method : </Typography>
                {method !== null && (
                    <Typography sx={{paddingLeft: 1, fontWeight: 500}}>{method}</Typography>
                )}
            </Stack>
            <Button variant="contained" fullWidth disabled={method === null} onClick={() =>handlePayNow()} >Pay Now</Button>
        </>
};

export default PaymentMethodXendit;